import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

//! REPLACE VALUES BELOW WITH YOUR OWN FIREBASE CONFIG
const firebaseConfig = {
  apiKey: "*****",
  authDomain: "*****",
  databaseURL: "*****",
  projectId: "*****",
  storageBucket: "*****",
  messagingSenderId: "*****",
  appId: "*****",
  measurementId: "*****",
};

export const USE_LOCAL_DEMO_AUTH = firebaseConfig.apiKey === "*****";

export const FIREBASE_APP = initializeApp(firebaseConfig);
export const FIREBASE_AUTH = USE_LOCAL_DEMO_AUTH
  ? (({
      currentUser: null,
      onAuthStateChanged: () => () => {},
    } as unknown) as ReturnType<typeof getAuth>)
  : getAuth(FIREBASE_APP);
export const FIREBASE_DB = getFirestore(FIREBASE_APP);
export const FIREBASE_STORAGE = getStorage(FIREBASE_APP);
